import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { Container, Row, Col } from 'react-bootstrap';
import meter1 from "../assets/img/meter1.svg"
import meter2 from "../assets/img/meter2.svg"
import meter3 from "../assets/img/meter3.svg"
import colrSharp from "../assets/img/color-sharp.png"
import CircularMeter from './CircularMeter';
const Skills = () => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return (
        <section className='skill' id="skills">
            <Container>
                <Row>
                    <Col>
                        <div className='skill-bx'>
                            <h2>
                                Skills
                            </h2>
                            <p>
                                Experienced MERN/MEAN developer with a transformative approach, specializing in crafting efficient solutions, optimizing workflows, and pushing technological boundaries for impactful program execution and seamless user experiences.
                            </p>
                            <Carousel responsive={responsive} infinite={true} className="skill-slider"
                            swipeable={true}
                            draggable={true}                            
                            autoPlay={true}
                            autoPlaySpeed={2500}
                            keyBoardControl={true}
                            partialVisible={true}
                            transitionDuration={500}
                            removeArrowOnDeviceType={["tablet", "mobile"]}
                            >
                                <div className='item-skill'>
                                    <CircularMeter value={80} />
                                    <h5>Angular</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={70} />
                                    <h5>React JS</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={75} />
                                    <h5>Node JS</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={72} />
                                    <h5>Express JS</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={50} />
                                    <h5>Mongo DB</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={90} />
                                    <h5>Javascript</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={85} />
                                    <h5>Typescript</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={80} />
                                    <h5>Git/Github</h5>
                                </div>
                                <div className='item-skill'>
                                    <CircularMeter value={95} />
                                    <h5>HTML/CSS</h5>
                                </div>

                            </Carousel>
                        </div>
                        <div>
                             {/* Pass your progress value here */}
                        </div>
                    </Col>
                </Row>
            </Container>
            <img src={colrSharp} className='background-image-left' alt="Image" />
        </section>
    )
}

export default Skills